// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPut, BASE_URL, retrieveToken } from "../../store/api";
import { JenisLembagaUpdateResponse } from "./types";

import * as jenisLembagaActions from "./jenisLembaga.actions";
import { showModal } from "../modal/modal.actions";

export function* updateJenisLembaga(
  action: ReturnType<typeof jenisLembagaActions.updateJenisLembagaAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `jenis-lembaga/${action.payload.ID}`;
    const result: Response = yield call(apiPut, url, token, action.payload);

    if (result.status === 200) {
      const parsed: JenisLembagaUpdateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'))
      yield put(jenisLembagaActions.updateJenisLembagaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisLembagaActions.updateJenisLembagaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(jenisLembagaActions.updateJenisLembagaAsync.failure(parsed));
  }
}

export default function* jenisLembagaSagaUpdateJenisLembaga() {
  yield takeEvery(jenisLembagaActions.updateJenisLembagaAsync.request, updateJenisLembaga);
}
